import ReportContentJson from "@pages/Report/components/ReportContentJson";
import { ReportContentProps } from "@shared/interfaces/ReportsFiles";

export const ReportContent: React.FC<ReportContentProps> = ({
  report,
  canComment,
  isReportEditing = false,
}) => {
  if (!report) {
    return <h1>Loading...</h1>;
  }

  try {
    // DO NOT remove, neccessary for parsing test
    JSON.parse(report.content);
    return (
      <ReportContentJson
        template_name={report.template_name}
        created_at={report.created_at}
        initialContent={report.content}
        initialTitle={report.name}
        canComment={canComment}
        isReportEditing={isReportEditing}
      />
    );
  } catch (e) {
    return <div className="flex-1 p-8">Report Format Not Supported</div>;
  }
};
